export enum AuthTokenError {
    GET = 'Unable to retrieve secret from sensitive storage',
    SET = 'Unable to set secret in sensitive storage',
    REMOVE = 'Unable to remove secret from sensitive storage',
    NO_SECRET = 'The secret for the given key seems to be missing',
}
